// extracted by mini-css-extract-plugin
module.exports = {"workspacesArea":"WorkspaceSelector_workspacesArea__XV4Gn","workspaceButton":"WorkspaceSelector_workspaceButton__OyOcE","workspaceActive":"WorkspaceSelector_workspaceActive__-C02T"};